module.exports = "img/photo5.6b59f9.jpeg";